import { v4 as uuidv4 } from "uuid";

const chillHop = () => {
  return [
    {
      name: "Beaver Creek",
      artist: "Middle School, Aso, Aviino",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10076",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Reflection",
      artist: "Swørn",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9228",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Keep Going",
      artist: "Swørn",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9222",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Beaver Creek",
      artist: "Middle School, Aso, Aviino",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10076",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Reflection",
      artist: "Swørn",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9228",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Keep Going",
      artist: "Swørn",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9222",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Beaver Creek",
      artist: "Middle School, Aso, Aviino",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10076",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Reflection",
      artist: "Swørn",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9228",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Keep Going",
      artist: "Swørn",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9222",
      color: ["#153742", "#1E352F"],
      id: uuidv4(),
      active: false,
    },
  ];
};

export default chillHop;
